'use strict';

require('../user/CurrentUserService.js');

function AuthService(
  $window,
  $state,
  $injector,
  $rootScope,
  config
) {
  var $http;
  return {
    getToken: function() {
      return $window.localStorage.token;
    },
    logout: function(isOut) {
      var CurrentUserService = $injector.get('CurrentUserService');
      $http = $http || $injector.get('$http');

      function killSession() {
        delete $window.localStorage.token;
        delete $window.localStorage.userId;
        delete $window.localStorage.language;

        CurrentUserService.destroy();

        $rootScope.$broadcast('auth-logout');
        if(isOut){
          window.location.href = '/login?isOut='+isOut;
        }else{
          window.location.href = '/login';
        }
      }

      if ($window.localStorage.token) {
        $http.delete(config.apiBase + '/tokens/' + $window.localStorage.token).success(killSession);
      }
      else {
        killSession();
      }
    }
};
}

angular.module('dokiv')
  .factory('AuthService', [
    '$window',
    '$state',
    '$injector',
    '$rootScope',
    'config',
    AuthService
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/auth/AuthService.js
// module id = 276
// module chunks = 0